import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Team } from '@/services/team'

export enum InviteState {
  /** 待接受 */
  pending = 1,
  /** 已同意 */
  allowed = 2,
  /** 已拒绝 */
  rejected = 3,
  /** 已取消 */
  canceled = 4,
  /** 已失效 */
  expire = 5,
}

export const InviteStateLabel: Record<InviteState, string> = {
  [InviteState.pending]: '待接受',
  [InviteState.allowed]: '已同意',
  [InviteState.rejected]: '已拒绝',
  [InviteState.canceled]: '已取消',
  [InviteState.expire]: '已失效',
}

export enum InviteActionType {
  /** 复制链接 */
  copyLink = 'copyLink',
  /** 取消邀请 */
  cancelInvite = 'cancelInvite',
  /** 再次邀请 */
  reInvite = 'reInvite',
}

export const InviteActionLabel: Record<InviteActionType, string> = {
  [InviteActionType.copyLink]: '复制链接',
  [InviteActionType.cancelInvite]: '取消邀请',
  [InviteActionType.reInvite]: '再次邀请',
}

export interface InviteListReq {
  page: number
  limit: number
  /** 1-待接受 2-已同意 3-已拒绝 4-已取消 5-已失效 */
  status?: number
  key_word?: string
}

export interface InviteItem {
  /** 手机号|账号 */
  account?: string
  /** 邀请时间戳 */
  ctime?: string
  /** 管理员备注 */
  remark?: string
  /** 角色ID */
  role_id?: string
  /** 角色名 */
  role_name?: string
  /** 状态：1-待接受 2-已同意 3-已拒绝 4-已取消 5-已失效 */
  status?: number
  /** 邀请团队ID */
  team_id?: number
  /** 过期时间 */
  expire_time?: number
}


export interface InviteListRes {
  total: number
  list: InviteItem[]
}


export interface CancelInviteReq {
  /** 账号手机号 */
  account?: string
}

@Injectable()
export class InviteListService {
  constructor (private http: Http, private team: Team) {
  }

  @ParamsClean()
  getInviteList (data: InviteListReq) {
    return this.http.post<InviteListRes>('/team/invite_admin/list', data)
  }

  @InvokeThrottle()
  cancelInvite (data: CancelInviteReq) {
    return this.http.post('/team/invite/cancel', data)
  }
}

